export default __webpack_public_path__ + "static/media/sidhant.f5903275.jpeg";